<mat-spinner *ngIf="!loaded"></mat-spinner>
<img [hidden]="!loaded" (load)="loaded = true" [src]="src" class="transition" [class.d-block]="loaded" [ngClass]="class"/>
